import { Component, Input } from '@angular/core';

// export const TL_TAB = new InjectionToken<TlTabComponent>('TlTab');

@Component({
  selector: 'tl-tab',
  template: `<ng-content *ngIf="active"></ng-content>`,
  host:{
    'class':'tl-tab',
  }
})
export class TlTabComponent {
  @Input('label') label: string = '';

  public active: boolean = false;

  constructor(
    // @Inject(forwardRef(() => TlTabsComponent)) private _parent: TlTabsComponent,
  ) {}

}
